<template>
  <b-container fluid>
    <form class="form" @submit.prevent="updateCuenta">
      <card class="my-card">
        <template v-slot:headerTitle>
          <span class="card-title my-2 h4"><b>Editar cuenta</b></span>
          <div>
            <span class="text-muted">General</span>
            <p style="width: 60%">Utilice el tipo de tarjeta de crédito para el saldo de apertura negativo.
              El número es esencial para conciliar las cuentas correctamente.
              La cuenta predeterminada registrará todas las transacciones si no se selecciona otra.</p>
          </div>
        </template>
        <h4 class="px-4 py-4"><b>Tipo de cuenta</b></h4>
        <div class="wrapper-fields">
          <div class="wrapper-input">
            <vs-button class="button"
                       :class="{ 'active-button': tipoCuenta !== 'banco' }"
                       v-on:click.prevent="cambiartipoCuenta('banco')">Banco
            </vs-button>
          </div>
          <div class="wrapper-input">
            <vs-button class="button" :class="{ 'active-button': tipoCuenta !== 'Card' }"
                       v-on:click.prevent="cambiartipoCuenta('Card')">Tarjeta de credito
            </vs-button>
          </div>
        </div>
        <h4 class="px-4 py-4"><b>Información General</b></h4>
        <div class="wrapper-fields">
          <div class="wrapper-input" title="Nombre">
            <label for="NombreCuenta">Nombre de la cuenta</label>
            <b-form-input id="NombreCuenta" name="NombreCuenta" required></b-form-input>
          </div>
          <div class="wrapper-input" title="Numero">
            <label for="NumeroCuenta">Numero</label>
            <b-form-input id="NumeroCuenta" name="NumeroCuenta" required></b-form-input>
          </div>
          <div class="wrapper-input" title="Divisa">
            <label for="DivisaId">Divisa</label>
            <HelexSelect id="DivisaId" name="DivisaId" :options="Listdivisas" optionLabel="nombre" optionValue="id"
                         v-model="infoDivisa.Id" required/>
          </div>
          <div class="wrapper-input" title="Saldo Inicial">
            <label for="SaldoInicial">Saldo inicial</label>
            <b-form-input id="SaldoInicial" type="number"
                          name="SaldoInicial"
                          required></b-form-input>
          </div>
        </div>
        <h4 v-if="tipoCuenta==='banco'" class="px-4 py-4"><b>Cuenta por defecto</b></h4>
        <div v-if="tipoCuenta==='banco'" class="wrapper-fields">
          <vs-button-group>
            <vs-button class="buttonDefault"
                       v-on:click.prevent="cambiarCuentaDefecto(true)"
                       :class="{'buttonDefaultActive': cuentaDefault}">
              SI
            </vs-button>
            <vs-button class="buttonDefault"
                       v-on:click.prevent="cambiarCuentaDefecto(false)"
                       :class="{'buttonDefaultFalse': !cuentaDefault}">
              NO
            </vs-button>
          </vs-button-group>
        </div>
        <h4 class="px-4 py-4"><b>Banco</b></h4>
        <div class="wrapper-fields">
          <div class="wrapper-input" title="Nombre del banco">
            <label for="NombreBanco">Nombre del banco</label>
            <b-form-input id="NombreBanco" name="NombreBanco"></b-form-input>
          </div>
          <div class="wrapper-input" title="Numero del banco">
            <label for="NumeroBanco">Numero del banco</label>
            <b-form-input id="NumeroBanco" name="NumeroBanco"></b-form-input>
          </div>
          <div class="wrapper-input" title="Direccion del banco">
            <label for="DireccionBanco">Direccion del banco</label>
            <b-form-textarea id="DireccionBanco" name="DireccionBanco"></b-form-textarea>
          </div>
        </div>
        <div class="wrapper-button" style="display: flex;">
          <vs-button class="button" dark @click.prevent="$router.push('/helex/Erp/Contabilidad/Banco/Cuentas')">
            Cancelar
          </vs-button>
          <vs-button class="button">Guardar</vs-button>
        </div>
      </card>
    </form>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      tipoCuenta: null,
      Listdivisas: [],
      infoDivisa: {},
      id: null,
      cuentaDefault:false,
    }
  },
  methods: {
    cambiartipoCuenta(tipo) {
      this.tipoCuenta = tipo;
    },
    cambiarCuentaDefecto(opcion) {
      this.cuentaDefault = opcion;
    },
    async updateCuenta(event) {
      var id = JSON.parse(localStorage.getItem("credenciales"))
      const cuenta = Object.fromEntries(new FormData(event.target).entries());
      cuenta["TipoCuenta"]=this.tipoCuenta;
      const data = {
        "Cuenta": cuenta,
        "CreadorId":id.personaId,
        "DivisaId": cuenta["DivisaId"]
      }
      delete cuenta["DivisaId"];
      console.log(data);
      try {
        let res = await this.$store.dispatch("hl_post", {
          path: "CONTAccount/ActualizarCuenta/"+this.id,
          data
        });
        if (res["respuesta"]) {
          this.$router.push('/helex/Erp/Contabilidad/Banco/Cuentas');
        } else {
          this.$vs.notification({
            position:'top-center',
            title:'Error',
            text: res["mensaje"]
          })
        }
      } catch (error) {
        this.Listdivisas = [];
        console.log(error)
        this.$vs.notification({
          position:'top-center',
          title:'Error',
          text: error
        })
      }
    }
  },
  async mounted() {
    this.id = this.$route.params.id;
    var idPersona = JSON.parse(localStorage.getItem("credenciales"));
    Promise.all([
      this.$store.getters.fetchGet({path: 'CONTAccount/ObtenerCuentaId/' + this.id}),
      this.$store.getters.fetchGet({path: 'GDivisas/ObtenerDivisasEmpresa/' +idPersona.personaId})
    ]).then(([infoAccount, ListDivisas]) => {
      return Promise.all([
        infoAccount.json(),
        ListDivisas.json()
      ]).then(([Account, Divisas]) => {
        console.log("cuenta: " + Account)
        this.Listdivisas = Divisas["data"];
        Object.keys(Account["data"]).forEach(key => {
          const input = this.$el.querySelector(`[name="${key}"]`);
          if (input) {
            input.value = Account["data"][key];
          }
          if (key === 'tipoCuenta') {
            this.tipoCuenta = Account["data"][key];
          }
          if (key === "DivisaId"){
            this.infoDivisa = Account["data"][key];
          }
        });
      })
    })
  }
}
</script>

<style scoped>
.wrapper-input {
  display: flex;
  flex-direction: column;
  margin-bottom: .5rem;
}

.wrapper-fields {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1rem;
  padding: 0 48px 16px;
}

.wrapper-button {
  align-self: flex-end;
  padding: 0 48px 16px;
}

.active-button {
  background-color: white !important;
  color: black !important;
  border: 2px solid black !important;
}

.buttonDefault {
  border-radius: 0 !important;
  color: black !important;
  background-color: #bfbfbf;
}

.buttonDefaultActive {
  color: black !important;
  background-color: #57ff14;
}

.buttonDefaultFalse {
  color: white !important;
  background-color: #ff1818;
}
</style>